package hk.com.vr360_demo2.webapp.component

import cc.easyandroid.easycompose.component.ComponentContext
import cc.easyandroid.easycompose.component.router.stack.ChildStack
import cc.easyandroid.easycompose.component.router.stack.StackNavigation
import cc.easyandroid.easycompose.component.router.stack.childStack
import cc.easyandroid.easycompose.component.router.stack.childStackWebNavigation
import cc.easyandroid.easycompose.component.router.stack.popToFirst
import cc.easyandroid.easycompose.component.router.stack.pushNew
import cc.easyandroid.easycompose.component.router.stack.replaceAll
import cc.easyandroid.easycompose.component.router.webhistory.WebNavigation
import cc.easyandroid.easycompose.component.value.Value
import hk.com.vr360_demo2.webapp.component.AppComponent.Child.*
import hk.com.vr360_demo2.webapp.component.DefaultAppComponent.Config.*
import hk.com.vr360_demo2.webapp.component.editor_rewrite.DefaultEditorRewriteComponent
import hk.com.vr360_demo2.webapp.component.home.DefaultHomeComponent
import hk.com.vr360_demo2.webapp.component.previewer.DefaultPreviewerComponent
import hk.com.vr360_demo2.webapp.component.verification.DefaultVerificationComponent
import hk.com.vr360_demo2.webapp.component.viewer.DefaultViewerComponent
import hk.com.vr360_demo2.webapp.utils.Url
import hk.com.vr360_demo2.webapp.utils.consumePathSegment
import hk.com.vr360_demo2.webapp.utils.path
import kotlinx.browser.window
import kotlinx.serialization.Serializable

class DefaultAppComponent(context: ComponentContext, deepLinkUrl: Url? = null) : AppComponent,
    ComponentContext by context {
    private val navigation = StackNavigation<Config>()

    private val _stack = childStack(
        source = navigation,
        serializer = Config.serializer(),
//        initialConfiguration = Config.Home,
        initialStack = { getInitialStack(deepLinkUrl) },
        childFactory = ::child,
    )
    override val stack: Value<ChildStack<*, AppComponent.Child>> = _stack
    override fun navigateToHome() {
        navigation.popToFirst()
    }


    override val webNavigation: WebNavigation<*> =
        childStackWebNavigation(
            navigator = navigation,
            stack = _stack,
            serializer = Config.serializer(),
            pathMapper = {
                when (val config = it.configuration) {
                    is Viewer -> buildString {
                        append("${Viewer.path}/${config.id}")
                        val queryParts = buildList {
                            config.uid?.takeIf { it.isNotBlank() }?.let { add("uid=$it") }
//                            config.token?.takeIf { it.isNotBlank() }?.let { add("token=$it") }
                        }
                        if (queryParts.isNotEmpty()) {
                            append("?")
                            append(queryParts.joinToString("&"))
                        }
                    }
                    is Previewer -> buildString {
                        append(Previewer.path)
                        val queryParts = buildList {
                            add("url=${config.url}")
                            if (config.autorotateEnabled) add("autorotate=true")
                        }
                        if (queryParts.isNotEmpty()) {
                            append("?")
                            append(queryParts.joinToString("&"))
                        }
                    }
//                    is Editor -> "${Editor.path}?id=${config.id}"
//                    is Verification -> "${Verification.path}?id=${config.id}&token=${config.token}"
                    is EditorRewrite -> "${EditorRewrite.path}/${config.id}"
                    else -> config.path
                }
            },
            childSelector = {
                when (val child = it.instance) {
                    is HomeChild -> null
                    is ViewerChild -> null
                    is PreviewerChild -> null
                    is EditorRewriteChild -> null
                    is VerificationChild -> null
                }
            },
        )

    private fun child(
        config: Config,
        componentContext: ComponentContext
    ): AppComponent.Child =
        when (config) {
            is Home -> HomeChild(
                DefaultHomeComponent(
                    componentContext,
                    token = config.token,
                )
            )

            is Viewer -> ViewerChild(
                DefaultViewerComponent(
                    componentContext,
                    config.id,
                    config.uid,
                    config.token,
                )
            )

            is Previewer -> PreviewerChild(
                DefaultPreviewerComponent(
                    context = componentContext,
                    url = config.url,
                    autorotateEnabled = config.autorotateEnabled,
                )
            )

            is EditorRewrite -> EditorRewriteChild(
                DefaultEditorRewriteComponent(componentContext, config.id, config.token)
            )
//            is Verification -> VerificationChild(
//                DefaultVerificationComponent(
//                    componentContext,
//                    config.id,
//                    config.token,
//                    ::navigateToEditor1
//                )
//            )
        }

    private fun getInitialStack(deepLinkUrl: Url?): List<Config> {
        val (path, childUrl) = deepLinkUrl?.consumePathSegment() ?: return listOf(Home())
        println("cgp childUrl =${deepLinkUrl} path = ${path} childUrl = ${childUrl}")
        return when (path) {
            Viewer.path -> {
                val id = deepLinkUrl.parameters["id"] ?: ""
                val uid = deepLinkUrl.parameters["uid"]
                var token = deepLinkUrl.parameters["token"]?:""
                if (token.isEmpty()) {
                    token = window.sessionStorage.getItem("editor_token") ?: ""
                }
                if (token.isNotEmpty()) {
                    window.sessionStorage.setItem("editor_token", token)
                }
                val (path, childUrl) = childUrl.consumePathSegment()
                listOf(Viewer(id = path ?: "", uid = uid, token = token))
            }
//            Verification.path -> {
//                val id = deepLinkUrl.parameters["id"] ?: ""
//                val token = deepLinkUrl.parameters["token"] ?: ""
//                listOf(Verification(id,token))
//            }
            EditorRewrite.path -> {
                val id = deepLinkUrl.parameters["id"] ?: ""
                var token = deepLinkUrl.parameters["token"] ?: ""
                if (token.isEmpty()) {
                    token = window.sessionStorage.getItem("editor_token") ?: ""
                }
                if (token.isNotEmpty()) {
                    window.sessionStorage.setItem("editor_token", token)
                }
                val (path, childUrl) = childUrl.consumePathSegment()
                listOf(EditorRewrite(path ?: "", token))
            }
            Previewer.path -> {
                val url = deepLinkUrl.parameters["url"] ?: ""
                val autorotateEnabled =
                    deepLinkUrl.parameters["autorotate"]?.equals("true", ignoreCase = true) == true
                listOf(Previewer(url = url, autorotateEnabled = autorotateEnabled))
            }

            else -> listOf(Home())
        }
    }

    @Serializable
    private sealed class Config {
        @Serializable
        abstract val path: String

        @Serializable
        class Home(val token: String? = null) : Config() {
            override val path: String = ""
        }

        @Serializable
        class Viewer(
            val id: String,
            val uid: String? = null,
            val token: String? = null,
        ) : Config() {
            override val path: String = Companion.path

            companion object {
                const val path: String = "view"
            }
        }

        @Serializable
        class EditorRewrite(val id: String, val token: String) : Config() {
            override val path: String = Companion.path

            companion object {
                const val path: String = "edit"
            }
        }

        @Serializable
        class Previewer(
            val url: String,
            val autorotateEnabled: Boolean = false,
        ) : Config() {
            override val path: String = Companion.path

            companion object {
                const val path: String = "preview"
            }
        }

    }
}